export const AUTH_STATE_CHANGE_EVENT = 'buyme:auth-changed';

export function dispatchAuthStateChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(AUTH_STATE_CHANGE_EVENT));
}
